import request from '@/utils/request'
// 获取评论列表，需要传递参数，来该变接口，target就是接口路径，参数2就是要查找的对象
// commentQuery会自动根据不同的值而匹配不同的
export const getComments = (target, commentQuery) => {
  return request.get(`/${target}comments/list`, {
    params: commentQuery
  })
}
export const changeThumbUp = (target, commentId) => {
  return request.post(`/${target}comments/thumbup?commentId=${commentId}`)
}
export const addComments = (target, commentDto) => {
  return request.post(`/${target}comments`, commentDto)
}
export const delComment = (target, commentId) => {
  return request.delete(`/${target}comments?commentId=${commentId}`)
}
// 获取未读消息的数量
export const getCount = (target) => {
  return request.get(`/${target}commentats`)
}
// 获取@我的消息列表
export const getAtList = (target, commentAtQuery) => {
  return request.get(`/${target}commentats/list`, {
    params: commentAtQuery
  })
}

// 将未读评论改成已读评论
export const changeCommentToRead = (target, createTime) => { // 获取所有未读消息以及已读消息的列表
  return request.put(`/${target}commentats?createTime=${createTime}`)
}
